
import Icon from '../../components/bases/icone/icon.js';

import AppBase from '../appBase.js';
import ToolsBar from '../../components/bases/toolsbar/toolsbar.js';



import User from "./appcomponents/user/user.js"
import AppHeader from './appcomponents/appheader/appheader.js';
import SelectLanguage from '../../components/bases/selectlanguage/selectlanguage.js';


import imgblue from "./assets/toolsbar/blue.png"
import imggreen from "./assets/toolsbar/green.png"
import imgcyan from "./assets/toolsbar/cyan.png"
import imgred from "./assets/toolsbar/red.png"
import imgmagenta from "./assets/toolsbar/magenta.png"
import imgyellow from "./assets/toolsbar/yellow.png"
import imgwhite from "./assets/toolsbar/white.png"

import imgleft from "./assets/toolsbar/gauche.png"
import imgcenter from "./assets/toolsbar/centre.png"
import imgright from "./assets/toolsbar/droite.png"
import imgcadenas from "./assets/toolsbar/cadenas.png"
import imgsimul from "./assets/toolsbar/simul.png"
import imgseek from "./assets/toolsbar/seek.png"

import imgdisplaytranscription from "./assets/toolsbar/display/transcription.png"
import imgdisplaysubtitles from "./assets/toolsbar/display/soustitres.png"
import imgdisplaytimeline from "./assets/toolsbar/display/timeline.png"
import imgdisplayspeakers from "./assets/toolsbar/display/speakers.png"
import imgdisplayplayer from "./assets/toolsbar/display/player.png"
import imgdisplaystats from "./assets/toolsbar/display/stats.png"

import imgtestTranscription from "./assets/tests/transcription.JPG"
import imgtestPlayer from "./assets/tests/player.JPG"
import imgtestSubtitles from "./assets/tests/st.JPG"
import imgtestSpeaker from "./assets/tests/speaker.JPG"
import imgtestTimeLine from "./assets/tests/timeline.JPG"
import imgtestStat from "./assets/tests/stat.JPG"



import {getCurrentProjectDatas, getMaxUndo, getCurrentMode, setCurrentMode} from "../../utils/software.js"

import {getCurrentUserDatas} from "../../utils/software.js"


import styles from "../appstyles/styles.module.css"


import ftva from "../../assets/ftva.png"
import easytt from "../../assets/logoEasyTTSmall.png"




import React from "react";
import { getColorByColorIndex } from '../../utils/colors.js';
import { apiCreateProjects } from '../../utils/apis.js';


class AppTests extends AppBase
{

    constructor (props)
    {
        super(props);
        
        const mode = getCurrentMode();

        this.state.modeA = mode.modeA;
        this.state.modeB = mode.modeB;
        this.state.modeC = mode.modeC;

        

        this.state.blocks= [
            {
                x:'0%',
                y:'0%',
                width:'33%',
                height:'69%',
                id: "transcription"
            },
            {
                x:'33%',
                y:'0%',
                width:'33%',
                height:'69%',
                id: "player"
            },
            {
                x:'66%',
                y:'0%',
                width:'33%',
                height:'69%',
                id: "subtitles"
            },

            {
                x:'0.5%',
                y:'70%',
                width:'99%',
                height:'29%',
                id: "timeline"
            },
            
        ];      // liste des blocs {id, x, y, width, height}
        

        /*
        this.state.blocks= [
            {
                x:'0%',
                y:'0%',
                width:'33%',
                height:'69%',
                id: "transcription"
            },
            {
                x:'66%',
                y:'0%',
                width:'33%',
                height:'69%',
                id: "subtitles"
            },

            
        ];      // liste des blocs {id, x, y, width, height}
        */
        this.state.nextId= 3;
        this.state.gridSize= 5;
        this.state.action= null;    // null | { type: 'drag', id, startMouseX, startMouseY, startX, startY } 
        this.activeid = "";



        this.state.toolsbar =
        { 
            height: 18,


            families:[
              {
                    fr: "couleurs",
                    en: "colors",

                items: [
                  {img: imgblue ,type:"button", disable:false,fr:"Bleu",en:"Blue", nochangecolor:true, key:{key:"BLUE", cat:"transcriptshortcut"}},
                  {img: imggreen ,type:"button", disable:false,fr:"Vert",en:"Green", nochangecolor:true, key:{key:"GREEN", cat:"transcriptshortcut"}},
                  {img: imgcyan ,type:"button", disable:false,fr:"Cyan",en:"Cyan", nochangecolor:true, key:{key:"CYAN", cat:"transcriptshortcut"}},
                  {img: imgred ,type:"button", disable:false,fr:"Rouge",en:"Red", nochangecolor:true, key:{key:"RED", cat:"transcriptshortcut"}},
                  {img: imgmagenta ,type:"button", disable:false,fr:"Magenta",en:"Magenta", nochangecolor:true, key:{key:"MAGENTA", cat:"transcriptshortcut"}},
                  {img: imgyellow ,type:"button", disable:false,fr:"Jaune",en:"Yellow", nochangecolor:true, key:{key:"YELLOW", cat:"transcriptshortcut"}},
                  {img: imgwhite ,type:"button", disable:false,fr:"Blanc",en:"White", nochangecolor:true, key:{key:"WHITE", cat:"transcriptshortcut"}},

                ],
              },
              {
                    fr: "alignement",
                    en: "aligment",

                items: [
                  {img: imgleft ,type:"button", disable:false,fr:"A gauche",en:"To left", nochangecolor:false, key:{key:"MOVESUBTITLETOLEFT", cat:"transcriptshortcut"}},
                  {img: imgcenter ,type:"button", disable:false,fr:"Au centre",en:"Center", nochangecolor:false, key:{key:"MOVESUBTITLETOCENTER", cat:"transcriptshortcut"}},
                  {img: imgright ,type:"button", disable:false,fr:"A droite",en:"To right", nochangecolor:false, key:{key:"MOVESUBTITLETORIGHT", cat:"transcriptshortcut"}},

                ],
              },

              {
                    fr: "mode",
                    en: "mode",

                items: [
                  {toogle: true, value:this.state.modeA, img: imgcadenas ,type:"button", disable:false,fr:"Faire suivre la vidéo",en:"Lock video", nochangecolor:false, key:{key:"LOCKVIDEO", cat:"mode"}},
                  {toogle: true, value:this.state.modeB, img: imgseek ,type:"button", disable:false,fr:"Faire suivre les sous-titres",en:"Lock subtitles", nochangecolor:false, key:{key:"LOCKSUBTITLES", cat:"mode"}},
                  {toogle: true, value:this.state.modeC, img: imgsimul ,type:"button", disable:false,fr:"Simulation en play",en:"Simulation when play", nochangecolor:false, key:{key:"SIMUL", cat:"mode"}},

                ],
              },

              {
                    fr: "Affichage",
                    en: "Display",

                items: [
                  {img: imgdisplayplayer ,type:"button", disable:false,fr:"Player",en:"Player", nochangecolor:false, key:{key:"DISPLAYER", cat:"display"}},
                  {img: imgdisplaytimeline ,type:"button", disable:false,fr:"TimeLine",en:"TimeLine", nochangecolor:false, key:{key:"DISTIMELINE", cat:"display"}},
                  {img: imgdisplaytranscription ,type:"button", disable:false,fr:"Transcription",en:"Transcription", nochangecolor:false, key:{key:"DISTRANSCRIPT", cat:"display"}},
                  {img: imgdisplaysubtitles ,type:"button", disable:false,fr:"Sous-Titres",en:"Subtitles", nochangecolor:false, key:{key:"DISSUBTITLES", cat:"display"}},
                  {img: imgdisplayspeakers ,type:"button", disable:false,fr:"Speakers",en:"Speakers", nochangecolor:false, key:{key:"DISSPEAKERS", cat:"display"}},
                  {img: imgdisplaystats ,type:"button", disable:false,fr:"Statistiques",en:"Statistics", nochangecolor:false, key:{key:"DISSTATS", cat:"display"}},

                ],
              },

            ],
          }        



            



                       //       | { type: 'resize', id, startMouseX, startMouseY, startWidth, startHeight, startX, startY }
        

        this.appHeaderRef = React.createRef();

        this.onClickToolsBar = this.onClickToolsBar.bind(this);
        this.onValidAllForm  = this.onValidAllForm.bind(this)
        
        
        this.containerBlockRef = React.createRef();
    }  


    canClose()
    {
      return true;
      
    }
    
    
    componentDidMount() {

    }
    // ****************************************************************************************
    // Juste for Grid
    // ****************************************************************************************
  
addBlock = () => {
    this.setState((prev) => ({
      blocks: [
        ...prev.blocks,
        { id: prev.nextId, x: 0, y: 0, width: 150, height: 150 },
      ],
      nextId: prev.nextId + 1,
    }));
  };

  removeBlock = (id) => {
    this.setState((prev) => ({
      blocks: prev.blocks.filter((b) => b.id !== id),
    }));
  };

  convertiPourcentToPixel(pourcentValue, maxValueInPixel)
  {
    // pourcentValue = String type "0%"
    const num = parseFloat(pourcentValue);
    return Math.round((num * maxValueInPixel) / 100);
  }
  convertiPixelToPourcent(pixelValue, maxValueInPixel)
  {
   
    const v= (pixelValue/maxValueInPixel)*100;
    return v.toFixed(2) + "%"
  }


  onBlockMouseDown = (id, e) => {
    // Clic sur la zone draggable (pas sur handle)
    e.stopPropagation();
    e.preventDefault();
    const { clientX, clientY } = e;
    const block = this.state.blocks.find((b) => b.id === id);

    if (!block) return;

    const container = this.containerBlockRef.current;
    if (!container) return;
    const rect = container.getBoundingClientRect();

    

    const startX = this.convertiPourcentToPixel(block.x, rect.width);
    const startY = this.convertiPourcentToPixel(block.y, rect.height);


    const action = {
        type: "drag",
        id,
        startMouseX: clientX,
        startMouseY: clientY,
        pstartX: block.x,
        pstartY: block.y,
        startX: startX,
        startY: startY,
        rect: rect,

    }

    

    this.setState({
      action: action,
      activeid: block.id,
    }, () => {
      window.addEventListener("mousemove", this.onMouseMove);
      window.addEventListener("mouseup", this.onMouseUp);
    });
  };

  onResizeHandleMouseDown = (id, direction, e) => {
    e.stopPropagation();
    e.preventDefault();
    const { clientX, clientY } = e;
    const block = this.state.blocks.find((b) => b.id === id);
    if (!block) return;

    const container = this.containerBlockRef.current;
    if (!container) return;
    const rect = container.getBoundingClientRect();

    const startX = this.convertiPourcentToPixel(block.x, rect.width);
    const startY = this.convertiPourcentToPixel(block.y, rect.height);
    const width = this.convertiPourcentToPixel(block.width, rect.width);
    const height = this.convertiPourcentToPixel(block.height, rect.height);


    this.setState({
      action: {
        type: "resize",
        direction, // 'se' ou 'nw'
        id,
        startMouseX: clientX,
        startMouseY: clientY,

        pstartWidth: block.width,
        pstartHeight: block.height,
        pstartX: block.x,
        pstartY: block.y,

        startWidth: width,
        startHeight: height,
        startX: startX,
        startY: startY,
      },
    }, () => {
      window.addEventListener("mousemove", this.onMouseMove);
      window.addEventListener("mouseup", this.onMouseUp);
    });
  };

  removeMouseListeners = () => {
    window.removeEventListener("mousemove", this.onMouseMove);
    window.removeEventListener("mouseup", this.onMouseUp);
  };

  onMouseMove = (e) => {
    const { action, blocks, gridSize } = this.state;
    if (!action) return;
    const container = this.containerBlockRef.current;
    if (!container) return;
    const rect = container.getBoundingClientRect();
    const { clientX, clientY } = e;
    const deltaX = clientX - action.startMouseX;
    const deltaY = clientY - action.startMouseY;

    if (action.type === "drag") {
      let newX = action.startX + deltaX;
      let newY = action.startY + deltaY;
      const blk = blocks.find((b) => b.id === action.id);
      if (!blk) return;
      // clamp avant snap


      const maxX = rect.width - this.convertiPourcentToPixel(blk.width,rect.width);
      const maxY = rect.height - this.convertiPourcentToPixel(blk.height,rect.height);

      newX = Math.max(0, Math.min(newX, maxX));
      newY = Math.max(0, Math.min(newY, maxY));
      
      
      // snap à la grille
      newX = Math.round(newX / gridSize) * gridSize;
      newY = Math.round(newY / gridSize) * gridSize;

      const pnewX = this.convertiPixelToPourcent(newX, rect.width);
      const pnewY = this.convertiPixelToPourcent(newY, rect.height);

      var newblocks = this.state.blocks.map (b => {
          return b.id === action.id ? { ...b, x: pnewX, y: pnewY } : b
      });
      var otherBlocks = newblocks.filter((b) => b.id !== action.id);
      var movedBlock = newblocks.find((b) => b.id === action.id);

   
      
   
      movedBlock = this.BlockToPixel(movedBlock, rect.width, rect.height);

      for (var i=0; i < otherBlocks.length; i++)
          otherBlocks[i] = this.BlockToPixel(otherBlocks[i], rect.width, rect.height)



      //newblocks  = this.resolveCollisions(movedBlock, otherBlocks,rect);
      //newblocks.push(movedBlock);


      console.log("return pixel ", newblocks);

      for (var i=0; i < newblocks.length; i++)
          newblocks[i] = this.BlockToPourcent(newblocks[i], rect.width, rect.height)


      
      this.setState({blocks: newblocks})

    }
    else if (action.type === "resize") 
        
        
    {
      const blk = blocks.find((b) => b.id === action.id);
      if (!blk) return;
      var newX = blk.x, newY = blk.y, newWidth = blk.width, newHeight = blk.height;

      newX = this.convertiPourcentToPixel(newX,rect.width);
      newY = this.convertiPourcentToPixel(newY,rect.height);
      newWidth = this.convertiPourcentToPixel(newWidth,rect.width);
      newHeight = this.convertiPourcentToPixel(newHeight,rect.height);


      const minW = 50, minH = 50;
      if (action.direction === "se") {
        // bottom-right: width + deltaX, height + deltaY, x,y inchangés
        newWidth = action.startWidth + deltaX;
        newHeight = action.startHeight + deltaY;


        // clamp taille
        newWidth = Math.max(minW, Math.min(newWidth, rect.width - action.startX));
        newHeight = Math.max(minH, Math.min(newHeight, rect.height - action.startY));
        // snap
        newWidth = Math.round(newWidth / gridSize) * gridSize;
        newHeight = Math.round(newHeight / gridSize) * gridSize;
        // clamp après snap
        newWidth = Math.max(minW, Math.min(newWidth, rect.width - action.startX));
        newHeight = Math.max(minH, Math.min(newHeight, rect.height - action.startY));
      }
      else if (action.direction === "nw") {
        // top-left: width - deltaX, height - deltaY; x + deltaX, y + deltaY
        let rawW = action.startWidth - deltaX;
        let rawH = action.startHeight - deltaY;
        let rawX = action.startX + deltaX;
        let rawY = action.startY + deltaY;
        // clamp position et taille de sorte que: newX>=0, newY>=0, newWidth>=minW, newHeight>=minH, newX+newWidth<=rect.width, newY+newHeight<=rect.height
        // Calculer newWidth/newX:
        // dX vers la droite (deltaX positif) réduit la largeur; si rawX < 0, on corrige
        // On doit d'abord clamp rawX entre 0 et action.startX+action.startWidth-minW
        let clampedX = Math.max(0, Math.min(rawX, action.startX + action.startWidth - minW));
        // newWidth = action.startWidth + (action.startX - clampedX)
        let calcWidth = action.startWidth + (action.startX - clampedX);
        // Même principe pour Y:
        let clampedY = Math.max(0, Math.min(rawY, action.startY + action.startHeight - minH));
        let calcHeight = action.startHeight + (action.startY - clampedY);
        // Ensuite clamp taille max pour ne pas dépasser bord droit/bas:
        calcWidth = Math.max(minW, Math.min(calcWidth, rect.width - clampedX));
        calcHeight = Math.max(minH, Math.min(calcHeight, rect.height - clampedY));
        // Snap à la grille:
        calcWidth = Math.round(calcWidth / gridSize) * gridSize;
        calcHeight = Math.round(calcHeight / gridSize) * gridSize;
        clampedX = action.startX + (action.startWidth - calcWidth);
        clampedY = action.startY + (action.startHeight - calcHeight);
        // Final clamp de position:
        newX = Math.max(0, Math.min(clampedX, rect.width - calcWidth));
        newY = Math.max(0, Math.min(clampedY, rect.height - calcHeight));
        newWidth = calcWidth;
        newHeight = calcHeight;
      }

      const pnewX = this.convertiPixelToPourcent(newX, rect.width);
      const pnewY = this.convertiPixelToPourcent(newY, rect.height);
      const pnewWidth = this.convertiPixelToPourcent(newWidth, rect.width);
      const pnewHeight = this.convertiPixelToPourcent(newHeight, rect.height);

      var newblocks = this.state.blocks.map (b => {
          return b.id === action.id ? { ...b, x: pnewX, y: pnewY, width: pnewWidth, height: pnewHeight } : b
      });

      this.setState ({blocks: newblocks});
    }
  };

  onMouseUp = () => {
    this.removeMouseListeners();
    this.setState({ action: null });
  };


  checkCollision(blockA, blockB) {
  return !(
    blockA.x + blockA.width <= blockB.x ||
    blockA.x >= blockB.x + blockB.width ||
    blockA.y + blockA.height <= blockB.y ||
    blockA.y >= blockB.y + blockB.height
  );
}

BlockToPixel(bloc, width, height)
{
    //console.log("BLOCK TO PIXEL AVANT ", bloc)
    bloc.x = this.convertiPourcentToPixel(bloc.x, width);
    bloc.y = this.convertiPourcentToPixel(bloc.y, height);
    bloc.width = this.convertiPourcentToPixel(bloc.width, width);
    bloc.height = this.convertiPourcentToPixel(bloc.height, height);
    //console.log("BLOCK TO PIXEL APRES ", bloc)
    return bloc;
  
}

BlockToPourcent(bloc, width, height)
{
    bloc.x = this.convertiPixelToPourcent(bloc.x, width);
    bloc.y = this.convertiPixelToPourcent(bloc.y, height);
    bloc.width = this.convertiPixelToPourcent(bloc.width, width);
    bloc.height = this.convertiPixelToPourcent(bloc.height, height);

    return bloc;
  
}

 
  // Suppression de l'écouteur lorsque le composant est démonté
    componentWillUnmount() {
        this.removeMouseListeners();
    }  
      


  onClickToolsBar(datas)
  {
    
    switch (datas.cat)
    {
      case "applocalshortcut":
        switch (datas.key)
        {
        }
        
    }
  }



  onValidAllForm(ret)
  {
      this.setState({displayEditCommonErrors: false})

  }

 
 render() 
 {

    const containerWidth = 800;
    const containerHeight = 600;
    const { gridSize } = this.state;



    const title = this.context.language=="fr"?"PAGE TESTS":"TESTS PAGE"
          
    
    return (
      <>
      <div className={styles.appDiv}>
        <div className={styles.appDivTop}>
          <div className={styles.appDivLogoFtva}>
              <img src={ftva} style = {{width:"100%", verticalAlign:"middle"}}/>
          </div>
          <div className={styles.appDivProject}>
              <div className={styles.appDivProjectLeft}>
              <h1>{title}</h1>
              </div>
              <div className={styles.appDivProjectRight}>
              <AppHeader ref={this.appHeaderRef} canclose={true}/>
              </div>

          </div>
          <div className={styles.appDivLogo}>
          <Icon image={easytt} height="100%" width="100%"/>
          </div>
          <div className={styles.appDivLanguage}>
             <SelectLanguage/>
          </div>
          <div className={styles.appDivUser}>
              <User onnavigate = {this.props.onnavigate} onCancelKeyboardEvent={this.onCancelKeyboardEvent}/>
          </div>
        </div>
        <div className={styles.appDivToolsBar}>
            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar}/>
        </div>
        <div className={styles.appDivBody} ref = {this.bodyDivRef}>
      <div className={styles.appPanelsContainer}>

        
        <div
          ref={this.containerBlockRef}
          style={{
            width: "99%",
            height: "100%",
            border: "2px solid #333",
            position: "relative",
            overflow: "hidden",
            marginTop: 10,
            backgroundColor:'transparent',
            userSelect: this.state.action ? "none" : "auto",
          }}
        >
          {this.state.blocks.map((block) => (
            <div
              key={block.id}
              style={{
                position: "absolute",
                left: block.x,
                top: block.y,
                width: block.width,
                height: block.height,
                boxSizing: "border-box",
                backgroundColor: "black",
                border: "1px solid #000",
                userSelect: "none",
                zIndex: this.state.activeid===block.id?1:0,
              }}
              onMouseDown={(e) => {

                
                if (e.target.classList.contains("resize-handle")) return;
                this.onBlockMouseDown(block.id, e);
              }}
            >
              <div style={{ paddingTop: "18px", width: "100%", height: "100%" }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    this.removeBlock(block.id);
                  }}
                  style={{
                    position: "absolute",
                    top: 1,
                    right: 1,
                    fontSize: 7,
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  ✕
                </button>
                <div className={styles.appBlockContainer} onMouseDown={(e) => {e.stopPropagation()}}>
                    {
                        block.id === "transcription"? <img width="100%" height="100%" src={imgtestTranscription}/>:
                            block.id === "player"?<img img width="100%" height="100%" src={imgtestPlayer}/>:
                                block.id === "subtitles"?<img img width="100%" height="100%" src={imgtestSubtitles}/>:
                                    block.id === "stat"?<img img width="100%" height="100%" src={imgtestStat}/>:
                                        block.id === "speaker"?<img img width="100%" height="100%" src={imgtestSpeaker}/>:
                                            <img img width="100%" height="100%" src={imgtestTimeLine}/>

                    }


                </div>
              </div>
              {/* handle SE en bas-droite */}
              <div
                className="resize-handle"
                onMouseDown={(e) => this.onResizeHandleMouseDown(block.id, "se", e)}
                style={{
                  position: "absolute",
                  width: 16,
                  height: 16,
                  right: 0,
                  bottom: 0,
                  cursor: "se-resize",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(0,0,0,0.1)",
                }}
              >
               <span style={{ fontSize: 12, color: "white", lineHeight: 1 }}>↘</span>
              </div>

              
              {/* handle NW en haut-gauche */}
              <div
                className="resize-handle"
                onMouseDown={(e) => this.onResizeHandleMouseDown(block.id, "nw", e)}
                style={{
                  position: "absolute",
                  width: 16,
                  height: 16,
                  left: 0,
                  top: 0,
                  cursor: "nw-resize",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(0,0,0,0.1)",
                }}
              >
                <span style={{ fontSize: 12, color: "white", lineHeight: 1 }}>↖</span>
              </div>
            </div>
          ))}
        </div>
      </div>



          </div>
              
      </div>
      </>
    

    );
}

}


export default AppTests;
